import React from 'react';
import DemandesBoard from './DemandesBoard';

export default function CongeTable() {
    return <DemandesBoard typeFilter="conge" withPeriod emptyLabel="Aucune demande de congé" />;
}
